import type { EventGuest } from "@anggunpraya-templates/types";

/**
 * Store shared untuk guest undangan aktif.
 *
 * Store ini hanya bertanggung jawab sebagai state holder. Policy untuk menentukan
 * apakah data berasal dari mode `preview`, `portfolio`, atau `event` nyata
 * sengaja dipindah ke loader composable agar store tetap sederhana.
 */
export const useEventGuestStore = defineStore("event-guest", () => {
  const loading = ref(false);
  const eventGuest = ref<EventGuest | null>(null);

  /**
   * Menyimpan guest aktif yang sudah dimuat oleh loader.
   *
   * @param guest Data guest aktif atau `null` bila tidak ada
   */
  function setEventGuest(guest: EventGuest | null) {
    eventGuest.value = guest;
  }

  /**
   * Menandai status loading untuk semua consumer shared.
   *
   * @param value Status loading terbaru
   */
  function setLoading(value: boolean) {
    loading.value = value;
  }

  /**
   * Mengembalikan state guest ke kondisi awal.
   */
  function reset() {
    loading.value = false;
    eventGuest.value = null;
  }

  return {
    eventGuest: computed(() => eventGuest.value),
    loading: computed(() => loading.value),
    setEventGuest,
    setLoading,
    reset,
  };
});
